import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=62667f8a&scoped=true&"
import script from "./Number.vue?vue&type=script&lang=js&"
export * from "./Number.vue?vue&type=script&lang=js&"
import style0 from "./Number.vue?vue&type=style&index=0&id=62667f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62667f8a",
  null
  
)

export default component.exports